module.exports = __webpack_public_path__ + "img/house.bc16027.png";